import { Amplify } from "aws-amplify";

let configured = false;

export function configureAmplify(): void {
  if (configured) return;
  const userPoolId = import.meta.env["VITE_COGNITO_USER_POOL_ID"] as string | undefined;
  const userPoolClientId = import.meta.env["VITE_COGNITO_USER_POOL_CLIENT_ID"] as string | undefined;
  if (!userPoolId || !userPoolClientId) {
    throw new Error(
      "VITE_COGNITO_USER_POOL_ID and VITE_COGNITO_USER_POOL_CLIENT_ID must be set at build time",
    );
  }
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: userPoolId,
        userPoolClientId: userPoolClientId,
        loginWith: { email: true },
      },
    },
  });
  configured = true;
}
